export default {
  archivesGrowUpDetail(params) {
    // 成长记录详情
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/archivesGrowUp`,
      params: params,
    });
  },
  // 阶段测评详情
  getArchivesStageTest(params) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/archivesStageTest/get`,
      params: params,
    });
  },
  // 获取机构详情.
  getShareCampusDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/cs-crm/public/campus',
      params: params,
    });
  },
  // 新建线索-学员分享录入“我也想学”
  intentionClueShareSubmit(params) {
    return app.http.ajax({
      method: 'post',
      url: '/cs-crm/intention/clue/shareSubmit',
      params: params,
    });
  },

  // 获取点评详情
  getCommentDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/public/comment/commentDetail`,
      params: params,
    });
  },
  getCommentReplyRecordPage(params) {
    return app.http.ajax({
      method: 'post',
      url: `/cs-edu/public/comment/getCommentReplyRecordPage`,
      params: params,
    });
  },
  answerInfo(id,cid) {
    return app.http.ajax({
      method: 'get',
      url: `/cs-edu/public/qanda/answerInfo?id=${id}&companyId=${cid}`,
    });
  },
  getArchivesReplyPage(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/cs-edu/public/archives/getArchivesReplyPage',
      params,
    });
  },
  // 课堂点评详情
  contentCommentDetail(params) {
    return app.http.ajax({
      method: "get",
      url: `/growth-hss/public/comment/detail?commentRecordId=${params.commentRecordId}&companyId=${params.companyId}`,
    })
  },
  // 成长记录详情
  growthRecordDetail(params) {
    return app.http.ajax({
      method: "get",
      url: `/growth-hss/public/growth/detail?growthRecordId=${params.growthRecordId}&companyId=${params.companyId}`,
    })
  },
  // 评论列表
  replyCommentList(params) {
    return app.http.ajax({
      url: '/growth-hss/public/parent/reply/commentList',
      params
    })
  },
  // 评论回复列表
  commentReplyList(params) {
    return app.http.ajax({
      url: '/growth-hss/public/parent/reply/commentReplyList',
      params
    })
  },
    // 下载信息查询
  fileDownloadInfo(params) {
    return app.http.ajax({
      url: '/cs-edu/public/fileDownload/info',
      params
    })
  },
};
